import React from "react";
import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecommendationDetails } from "../../RecommendationDetailsProvider";
import { BarChartBlock } from "./BarChartBlock";
import { TwoColLayout } from "./TwoColLayout";
import { LegendBlock } from "./LegendBlock";

interface Props {
  risk: {
    value: number;
    name: string;
  };
  performance: {
    value: number;
    name: string;
  };
}

export const RiskPerformanceSection = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { recommendation, originalFund, names } = useRecommendationDetails();

  return (
    <>
      <TwoColLayout
        component1={
          <BarChartBlock
            investmentName={names.investment}
            recommendationName={names.recommendation}
            investmentValue={originalFund?.performance ?? 0}
            recommendationValue={recommendation.fund.performance ?? 0}
            title="recommender.compareView.performanceRisk.yieldTitle"
            chartLabel="recommender.compareView.performanceRisk.yieldLabel"
            titleTooltip="recommender.compareView.performanceRisk.yieldTooltip"
          />
        }
        component2={
          <BarChartBlock
            investmentName={names.investment}
            recommendationName={names.recommendation}
            investmentValue={originalFund?.volatility ?? 0}
            recommendationValue={recommendation.fund.volatility ?? 0}
            title="recommender.compareView.performanceRisk.riskTitle"
            titleTooltip="recommender.compareView.performanceRisk.riskTooltip"
            chartLabel="recommender.compareView.performanceRisk.riskLabel"
            showSmaller
          />
        }
        title={t("recommender.compareView.performanceRisk.title")}
      />
      <LegendBlock
        ogFundName={names.investment}
        recommendationName={names.recommendation}
        margin={theme.spacing(6, 0, 0, 0)}
      />
    </>
  );
};
